var map = {
	"./Homepage": [
		9717
	],
	"./Homepage.jsx": [
		9717
	],
	"./bohren/Screensaver": [
		3929
	],
	"./bohren/Screensaver.jsx": [
		3929
	],
	"./bohren/Startseite": [
		1924
	],
	"./bohren/Startseite.jsx": [
		1924
	],
	"./bohren/Taste1": [
		1106,
		58,
		106
	],
	"./bohren/Taste1.jsx": [
		1106,
		58,
		106
	],
	"./bohren/Taste2": [
		4089,
		58,
		89
	],
	"./bohren/Taste2.jsx": [
		4089,
		58,
		89
	],
	"./bohren/Taste3": [
		3332,
		58,
		332
	],
	"./bohren/Taste3.jsx": [
		3332,
		58,
		332
	],
	"./bohren/Taste4": [
		8347,
		58,
		347
	],
	"./bohren/Taste4.jsx": [
		8347,
		58,
		347
	],
	"./quiz/QuizLeicht": [
		3073
	],
	"./quiz/QuizLeicht.jsx": [
		3073
	],
	"./quiz/QuizSchwer": [
		9976
	],
	"./quiz/QuizSchwer.jsx": [
		9976
	],
	"./quiz/QuizScreenSaver": [
		3617
	],
	"./quiz/QuizScreenSaver.jsx": [
		3617
	],
	"./quiz/QuizStartseite": [
		1968
	],
	"./quiz/QuizStartseite.jsx": [
		1968
	],
	"./tragen/Screensaver": [
		6946
	],
	"./tragen/Screensaver.jsx": [
		6946
	],
	"./tragen/Startseite": [
		8623
	],
	"./tragen/Startseite.jsx": [
		8623
	],
	"./tragen/Taste1": [
		6433,
		58,
		433
	],
	"./tragen/Taste1.jsx": [
		6433,
		58,
		433
	],
	"./tragen/Taste2": [
		4714,
		58,
		714
	],
	"./tragen/Taste2.jsx": [
		4714,
		58,
		714
	],
	"./tragen/Taste3": [
		9159,
		58,
		159
	],
	"./tragen/Taste3.jsx": [
		9159,
		58,
		159
	],
	"./ziehen/Screensaver": [
		4462
	],
	"./ziehen/Screensaver.jsx": [
		4462
	],
	"./ziehen/Startseite": [
		1053
	],
	"./ziehen/Startseite.jsx": [
		1053
	],
	"./ziehen/Taste1": [
		4799,
		58,
		799
	],
	"./ziehen/Taste1.jsx": [
		4799,
		58,
		799
	],
	"./ziehen/Taste2": [
		2468,
		58,
		468
	],
	"./ziehen/Taste2.jsx": [
		2468,
		58,
		468
	],
	"./ziehen/Taste3": [
		9017,
		58,
		17
	],
	"./ziehen/Taste3.jsx": [
		9017,
		58,
		17
	],
	"./ziehen/Taste4": [
		4494,
		58,
		494
	],
	"./ziehen/Taste4.jsx": [
		4494,
		58,
		494
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 629;
module.exports = webpackAsyncContext;